import React from 'react';
import { Cpu, ShieldCheck, Plug } from 'lucide-react';
import PhasePageTemplate from './PhasePageTemplate';

const integrationList = [
  'AccuLynx', 'JobNimbus', 'CompanyCam', 'ProLine',
  'RoofLink', 'HailTrace', 'Dialpad', 'CallRail',
];

const PhaseBuild = () => (
  <PhasePageTemplate
    phaseNumber="03"
    phaseName="Building Your Agent"
    tagline="We do the work. You wait. Your agent is trained, your integrations are connected, your hardware is locked down and tested before it ever ships."
    heroImage="/images/generated/process-hero-build.png"
    conceptImage="/images/generated/process-concept-build.png"
    delivers={[
      {
        icon: <Cpu className="w-6 h-6" />,
        title: 'A Trained Agent',
        desc: 'Your agent is built from your Strategy Call transcript. It knows your business, your language, your priorities — not a generic out-of-the-box AI.',
      },
      {
        icon: <Plug className="w-6 h-6" />,
        title: 'Connected Integrations',
        desc: 'We connect up to three platforms from your integration map — the ones that matter most to how you actually work. Pre-built for the most common roofing tools.',
      },
      {
        icon: <ShieldCheck className="w-6 h-6" />,
        title: 'A Hardened Machine',
        desc: 'Your hardware is configured, encrypted, and tested before it ships. We don\'t hand you something half-built. It works the moment it arrives.',
      },
    ]}
    whyTitle="Trained, not templated."
    whyBody="A lot of AI tools hand you a blank slate and call it done. We don't. Before your machine ships, your agent has read your transcript, learned your tools, and been tested against the real workflows you described on your Strategy Call. We build pre-configured connections for the most common roofing platforms — AccuLynx, JobNimbus, RoofLink, ProLine, CompanyCam, HailTrace, Dialpad, CallRail. If your platform isn't on that list, we research it and build the connection. This phase is where most of the work happens. You don't see it — and that's the point."
    experienceTitle="Nothing required from you."
    experienceBody="This is the phase where you wait — and we work. You have full visibility on your build status in your client portal. We test your agent against the scenarios from your Strategy Call before we even consider shipping. If something doesn't work the way it should, we fix it here, not after it's on your desk."
    experienceHighlights={[
      'Build progress visible in your portal — no need to chase us for updates',
      'Agent tested against your actual workflows before shipping',
      'We notify you the moment your machine ships, with tracking',
    ]}
    timeline="5–7 business days"
    mockupImage="/images/generated/mockup-credentials.jpg"
    mockupCaption="Credentials submitted via one-time secure link — never emailed, never stored here."
    todoItems={[
      'Nothing. This is our phase.',
      'Keep an eye on your portal for status updates',
      'Respond quickly if we reach out with a question about your setup',
    ]}
    prevPhase={{ name: 'The Strategy Call', href: '/process/strategy-call' }}
    nextPhase={{ name: 'Secure Delivery', href: '/process/delivery' }}
  />
);

export default PhaseBuild;
